<template>
  <div class="page page2 single">
    <van-form @submit="submitForm">
      <div class="tg-single">
        <van-uploader
          id="upload-wrap"
          class="upload-wrap"
          :after-read="handleUpload"
          :before-read="beforeUpload"
          :max-count="1"
          ref="uploadFile"
        >
          <div class="tg-single-wrap">
            <img
              class="upload-pic-single"
              :src="form.image"
              v-show="isUploaded"
            />
            <img class="upload-error-txt" :src="bg[1]" v-show="!isUploaded" />
            <span class="upload-txt" v-show="isUploaded">更换图片</span>
            <van-loading size="24px" type="spinner" vertical v-show="loading"
              >上传中...</van-loading
            >
          </div>
        </van-uploader>
        <div class="input-wrap" @click="chooseFromSys"></div>
      </div>
      <div class="tips" v-if="msg != ''">
        {{ msg }}
      </div>
      <div class="tips">
        *本赛事仅支持{{ gourp_limit.typestr }}格式且不大于{{
          gourp_limit.size
        }}M的图片
      </div>
      <div class="form">
        <div class="info-ipt">
          <van-field
            class="required"
            v-model="form.mname"
            name="作品标题"
            label="作品标题"
            maxlength="15"
            placeholder="请输入15字以内作品名称"
            :rules="[{ required: true, message: '作品标题不能为空' }]"
          />
          <van-field
            class="required"
            v-model="form.custom_fields.shoot_date"
            name="拍摄日期"
            label="拍摄日期"
            placeholder="请输入拍摄日期 例：2000-01-01"
            :rules="[{ required: true, message: '拍摄日期不能为空' }]"
          />
          <van-field
            class="required"
            v-model="form.shoot_address"
            name="拍摄地址"
            label="拍摄地址"
            placeholder="请输入作品拍摄地"
            :rules="[{ required: true, message: '拍摄地址不能为空' }]"
          />
          <van-field
            class="required"
            v-model="form.remark"
            rows="5"
            autosize
            label="作品说明"
            type="textarea"
            maxlength="1000"
            placeholder="请输入作品说明"
            :rules="[{ required: true, message: '作品说明不能为空' }]"
            show-word-limit
          />
        </div>
        <div class="submit-item">
          <label @click="isPromise = !isPromise">
            <input class="check" type="checkbox" :checked="isPromise" />
            <span class="text"> 本人承诺递交的记录类作品未对原始影像进行违规处理</span>
          </label>
        </div>
        <div class="submit-item">
          <label @click="changeSync">
            <input class="check" type="checkbox" :checked="form.is_app_show" />
            <span class="text" @click.stop> 我同意将该图片同步到app发现中</span>
          </label>
        </div>
        <div class="agreement-tips">
          发布即表示您已同意我们的<a
            href="https://www.pai2345.com/wap/treaty/index/id/9"
            >原创条款</a
          >
        </div>
        <van-button
          class="btn-submit"
          round
          block
          type="warning"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
    <ChooseFile
      :chooseForm1="chooseForm1"
      :uploadImages="uploadImages"
      :limit="1"
      :max="1"
      :chooseType="chooseType"
      @changeChooseForm1="changeChooseForm1"
      @changeChooseForm2="changeChooseForm2"
      @chooseFromSys="chooseFromSys"
      @chooseComplete="chooseComplete"
    />
  </div>
</template>

<script>
// import store from "@/store";
import ChooseFile from "@/components/ChooseFile";
import EXIF from "exif-js";
export default {
  components: {
    ChooseFile,
  },
  data() {
    return {
      id: this.$route.params.id,
      group: this.$route.query.group,
      bg: [
        require("@/static/images/tg-single-bg.png"),
        require("@/static/images/tg-single-img.png"),
      ],
      // 是否传过图片
      isUploaded: false,
      define: [],
      custom_fields: [],
      form: {
        work_id: this.$route.query.work_id,
        match_id: this.$route.params.id,
        mname: "",
        remark: "",
        image: "",
        group: this.$route.query.group,
        shoot_address: "",
        custom_fields: [],
        // 是否同意条款
        is_app_show: 0,
        is_finding: 0,
        works_type: 1,
      },
      loading: false,
      formData: {},
      imageUrl: require("@/static/images/web_single-bg.png"),
      imageBg: require("@/static/images/web_single-bg.png"),
      isShowTips: false,
      isSubmit: false,
      msg: "",
      gourp_limit: {
        size: 0,
        imgtype: [],
        typestr: "",
        is_open_psd: 0,
      },
      chooseForm1: false,
      chooseForm2: false,
      uploadImages: [],
      chooseType: "single",
      checkExif: false,
      isPromise: true,
    };
  },
  methods: {
    changePhotos() {
      this.chooseForm1 = true;
      // 适配组件的参数类型
      // 传递到子组件的是数组，重组this.uploadImages为数组，以免数据格式报错
      this.uploadImages = [];
      this.uploadImages.push({ url: this.form.image });
    },
    changeChooseForm1(val) {
      this.chooseForm1 = val;
    },
    changeChooseForm2(val) {
      this.chooseForm2 = val;
    },
    chooseFromSys() {
      this.$refs.uploadFile.chooseFile();
    },
    chooseComplete(val) {
      if (val && val.length > 0) {
        this.form.image = val[0].up_url;
        this.isUploaded = true;
        this.loading = false;
        this.form.mname = this.form.mname || val[0].title || "";
        this.form.remark = this.form.remark || val[0].content || "";
      }
    },
    changeSync() {
      this.form.is_app_show = !this.form.is_app_show;
    },
    beforeUpload(file) {
      //类型判断need imgtype: [],
      let isJPG = this.tools.hasImgType(this.gourp_limit.imgtype, file.type);
      let isLt2M = file.size / 1024 / 1024 < this.gourp_limit.size;
      if (!isJPG) {
        this.$toast.fail(
          "上传图片只能是 " + this.gourp_limit.typestr + " 格式!"
        );
        return false;
      }
      if (file.size / 1024 / 1024 < 3) {
        this.$toast.fail(
          "上传文件大小不能小于3MB!"
        );
        return false;
      }
      if (!isLt2M) {
        this.$toast.fail(
          "上传图片大小不能超过 " + this.gourp_limit.size + "MB!"
        );
        return false;
      }
      return isJPG && isLt2M;
    },
    handleUpload(option) {
      // console.log('option', option);
      let that = this;
      this.form.custom_fields.shoot_date = "";
      this.form.shoot_address = "";
      this.checkExif = false;
      EXIF.getData(option.file, function(){
        var exifData = EXIF.getAllTags(this);
        // console.log('exif===========', exifData);
        // 判断exif信息
        if(typeof exifData.DateTimeOriginal !== 'undefined'){
          let dateTime = exifData.DateTimeOriginal.replace(/:/g, "-");
          dateTime = dateTime.split(" ");
          that.form.custom_fields.shoot_date = dateTime[0];
          that.checkExif = true;
          that.$forceUpdate();
        }
        // 判断是否有坐标信息
        if(typeof exifData.GPSLatitude !== 'undefined'){
          let latitude = exifData.GPSLatitude[0]+exifData.GPSLatitude[1]/60+exifData.GPSLatitude[2]/60/60;
          let longitude = exifData.GPSLongitude[0]+exifData.GPSLongitude[1]/60+exifData.GPSLongitude[2]/60/60;
          // console.log(latitude, longitude);
          // 经纬度转换  GPS -> 高德
          AMap.plugin('AMap.convertFrom', function () {
            AMap.convertFrom([longitude, latitude], "gps", function (status, result) {
              if (result.info === 'ok') {
                let lnglat = result.locations[0].lng + "," + result.locations[0].lat;
                AMap.plugin('AMap.Geocoder', function() {
                var geocoder = new AMap.Geocoder({
                  // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                  city: '全国'
                })
                geocoder.getAddress(lnglat.split(","), function(status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                      // result为对应的地理位置详细信息
                      // console.log('Geocoder', result);
                      that.form.shoot_address = result.regeocode.formattedAddress;
                      that.$forceUpdate();
                    }
                  })
                })
                
              }
            });
          });
        }
      });
      var file = option.file;
      file.status = "uploading";
      file.message = "上传中...";
      that.loading = true;
      that.tools.uploadaly(file).then((res) => {
        if (res) {
          that.form.image = res;
          that.isUploaded = true;
          that.loading = false;
          // 单图上传成功，说明是系统选图 应当撤销图库选择状态
          sessionStorage.removeItem("checkVal");
        } else {
          console.log(res);
        }
      });
    },
    submitForm() {
      if (!this.$store.state.isLogin) {
        /* eslint-disable */
        // 调用passport
        passportLogin.login();
        /* eslint-enable */
        return false;
      }
      if (this.isSubmit == false) {
        if (this.form.image == "") {
          this.$toast.fail("请先上传图片");
          return false;
        }
        if (this.loading) {
          this.$toast.fail("图片上传中，请稍候...");
          return false;
        }
        // if (!this.checkExif) {
        //   this.$toast.fail("图片缺少EXIF完整信息");
        //   return false;
        // }
        if (!this.isPromise) {
          this.$toast.fail("请确定承诺");
          return false;
        }
        let custom_fields = {
          shoot_date: this.form.custom_fields.shoot_date,
        };
        this.isSubmit = true;
        this.axios
        .post("/match/join_single", {
          work_id: this.form.work_id,
          match_id: this.form.match_id,
          mname: this.form.mname,
          remark: this.form.remark,
          image: this.form.image,
          group: this.form.group,
          shoot_address: this.form.shoot_address,
          custom_fields: custom_fields,
          is_finding: this.form.is_app_show,
          works_type: 1,
          source: 1,
        })
        .then(
          (res) => {
            if (res.data.code == 200) {
              if (this.form.work_id > 0) {
                // 作品的再投一稿
                sessionStorage.removeItem("checkVal");
                this.$router.push({
                  query: {
                    group: this.group,
                  },
                });
              }
              this.$dialog
                .confirm({
                  title: "",
                  message: "投稿成功!",
                  confirmButtonText: "再投一稿",
                  cancelButtonText: "返回赛事页",
                })
                .then(() => {
                  // on confirm
                  window.location.reload();
                  sessionStorage.removeItem("checkVal");
                })
                .catch((action) => {
                  // on cancel
                  console.log('action', action);
                  // this.$router.push({
                  //   path: "/detail/" + that.id + "/myworks",
                  // });
                  this.$router.push({
                    name: "intro",
                  });
                  sessionStorage.removeItem("checkVal");
                });
            } else {
              // this.$toast.fail(res.data.msg);
              this.$toast.fail({
                message: res.data.msg,
                duration: 3500,
                className: "long-toast",
              });
            }
            this.isSubmit = false;
          },(err) => {
            this.isSubmit = false;
            console.log('err', err);
          }
        );
      }
    },
  },
  mounted() {
    // 每次加载都清空图库选择状态
    sessionStorage.removeItem("checkVal");
    // 获取比赛详情
    this.tools
      .getMatchDetail({ id: this.id, group: this.group })
      .then((res) => {
        this.custom_fields = res.custom_fields;
        // 赛事提示
        this.msg = res.match_limit.match_introduce;
        this.form.is_app_show = res.match_limit.is_app_show;
        if (res.gourp_limit) {
          this.gourp_limit = Object.assign(this.gourp_limit, res.gourp_limit);
          this.gourp_limit.size = res.gourp_limit.file_limit_single;
          this.gourp_limit.imgtype = res.gourp_limit.file_limit_type_single;
          this.gourp_limit.typestr = this.gourp_limit.imgtype.toString();
        }
      });
    if (this.$route.query.work_id) {
      this.tools
        .getWorksDetail({ work_id: this.$route.query.work_id })
        .then((res) => {
          Object.assign(this.form, res.form);
          this.form.image = res.image;
          this.isUploaded = true;
        });
    }
  },
};
</script>

<style lang="scss">
.page2 {
  min-height: 100vh;
}
.single {
  textarea {
    word-break: break-all;
    word-wrap: break-word;
  }
  .van-field__label {
    width: 180px;
  }
  .required {
    .van-field__label {
      span::after {
        content: "*";
        color: #dd855c;
        position: absolute;
        left: 18px;
        top: 30px;
      }
    }
  }
  .van-uploader,
  .input-wrap {
    height: 375px;
    overflow: hidden;
  }
  .input-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .van-uploader__input-wrapper {
    width: 100vw;
  }
  .van-loading {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    .van-loading__spinner,
    .van-loading__text {
      position: relative;
      top: 45%;
      transform: translateY(-45%);
    }
    .van-loading__text {
      color: #fff;
    }
  }
  .van-button {
    line-height: 1;
  }
}
.long-toast {
  width: 80%;
  max-width: 80%;
}
</style>
